
    <div class="notification-box--wrapper">
      <div class="notification-box--casing">
        <notification [notification]="notification" *ngFor="let notification of stack"></notification>
      </div>
    </div>
  